import React, { useState } from "react";
import {
  Box,
  Button,
  Typography,
  Card,
  Grid,
} from "@mui/material";
import { Link, useLocation } from "react-router-dom";

import SampleImg from "../../assets/sample_img.png";
import backArrow from "../../assets/backArrow.png";
import whatsApp from "../../assets/whatsapp1.png";

import OrderSuccess from "./OrderSuccess";
import UploadFailedPopup from "./UploadFailedPop";
import ServerBusyModal from "./ServerBusyModal";
import WaitingLoder from "../../WaitingLoader/component";
import BottomNavBar from "../../BottomNav/Bottom.jsx";
import RefundStatus from "./New_HELP/new_help.jsx";

const CheckOrderStatus = (props) => {
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const isWebview = params.get("webview");
  const [image] = useState(SampleImg);

  const HelpHeader = () => (
    <Box
      sx={{
        height: 64,
        bgcolor: "#FFE03E",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        px: 2,
        position: "fixed",
        width: "100%",
        top: 0,
        zIndex: 1000,
      }}
    >
      <Box display="flex" alignItems="center">
      {/*   <Link to="/">
          <img src={backArrow} alt="Back" width={24} />
        </Link> */}
        <Typography ml={2} fontWeight="bold" color="#4A3F35">
          Help & Support
        </Typography>
      </Box>

     
    </Box>
  );


  if (props?.orderReport) return <RefundStatus{...props} />;

  return (
    <>
    <>
      {!isWebview && <HelpHeader />}
      {!isWebview && props?.showBottomFlag && <BottomNavBar />}
      {props?.loader && <WaitingLoder />}

      {props?.uploadFailed && (
        <UploadFailedPopup
          setUploadFailed={props.setUploadFailed}
          uploaderror={props.uploaderror}
          setLoader={props.setLoader}
        />
      )}

      {props?.serverBusy && (
        <ServerBusyModal
          setServerBusy={props.setServerBusy}
          onTryAgain={props.onServerBusyRetry}
        />
      )}

      {/* Uploading Overlay */}
      {props?.uploadingFlag && (
        <div className="overlay">
          <div className="popup">
            <div className="file-info">
              <div className="icon-placeholder">📄</div>
              <div className="file-details">
                <div className="filename">{props.fileName}</div>
                <div className="filesize">{props.fileSize} KB</div>
              </div>
            </div>
            <div className="spinner"></div>
            <div className="uploading-text">UPLOADING...</div>
          </div>
        </div>
      )}

      {<Box
        sx={{
          minHeight: "100vh",
          bgcolor: "#f4f6f5",
          pt: { xs: 10, md: 12 },
          pb: 6,
              mb: "50px"
        }}
      >
        <Box maxWidth={900} mx="auto" px={2}>
          <Grid container justifyContent="center">
            <Grid item xs={12} md={8}>
              <Card sx={{ p: 4, borderRadius: 3 }}>
                <Typography
                  fontSize={16}
                  fontWeight={600}
                  color="#583C43"
                  mb={1}
                  textAlign="start"
                >
                  Check Order Status
                </Typography>

                <Typography
                  fontSize={12}
                  color="text.secondary"
                  mb={3}
                  textAlign="start"
                >
                  Upload Payment Screenshot With Order ID
                </Typography>

                {/* Image Box */}
                <Box
                  sx={{
                    border: "2px dashed #ccc",
                    borderRadius: 2,
                    minHeight: 280,
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    alignItems: "center",
                    mb: 3,
                    gap: 2,
                  }}
                >
             <Box
  component="img"
  src={
    props?.uploadSumbitFlag
      ? props.previewImage
      : SampleImg
  }
  sx={{
    width: { xs: "auto", md: "70%" },   // full width on desktop
    maxWidth: "100%",
    maxHeight: {
      xs: props?.uploadSumbitFlag ? 220 : "auto", // mobile preview cap
      md: "none",                                  // no limit on desktop
    },
    objectFit: "contain",
    borderRadius: 2,
  }}
/>

                    {props?.uploadSumbitFlag && (
            <Box
  component="label"
  htmlFor="fileInput"
  className="button-17"
  sx={{
    boxShadow: "rgb(0 0 0 / 46%) 0px 4px 12px",
    borderRadius: "7px",
    fontSize: "14px",
    cursor: "pointer",
    border: "2px solid #b6b9b7",
    position: "absolute",
    top: {
      xs: "414px",
      md: "919px",
    },
  }}
>
  Change Image
  <input
    type="file"
    id="fileInput"
    accept="image/*"
    hidden
    onChange={props.UploadImgFun}
  />
</Box>

              )}
                </Box>

                <Typography
                  fontSize={12}
                  color="#583C43"
                  mb={3}
                  textAlign="center"
                >
                  Make sure screenshot clearly shows{" "}
                  <b>order_xxxxxxxxxxxxxxxx</b> (16 digit order ID)
                </Typography>

                {/* Action Button */}
                <Box display="flex" justifyContent="center">
                  {props?.uploadSumbitFlag ? (
                    <Button
                      variant="contained"
                      sx={{
                        width: "50%",
                        py: 1.5,
                        bgcolor: "#0AA36D",
                        textTransform: "none",
                        "&:hover": { bgcolor: "#0AA36D" },
                      }}
                      onClick={(e) => props.UploadImgBtn(e, image)}
                    >
                      Submit
                    </Button>
                  ) : (
                    <Button
                      variant="contained"
                      component="label"
                      sx={{
                        width: "50%",
                        py: 1.5,
                        bgcolor: "#0AA36D",
                        textTransform: "none",
                        "&:hover": { bgcolor: "#0AA36D" },
                      }}
                    >
                      Upload Image
                      <input
                        type="file"
                        hidden
                        accept="image/*"
                        onChange={props.UploadImgFun}
                      />
                    </Button>
                  )}
                </Box>
              </Card>
            </Grid>
          </Grid>
        </Box>
      </Box>}
    </>
    </>
  );
};

export default CheckOrderStatus;
